<template>
    <v-container fill-height="fill-height">
        <v-layout>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4">
                    <h1 class="red--text">
                        Page not found
                    </h1>
                </v-col>
            </v-row>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: '404',
};
</script>

<style scoped>

</style>
